import React from 'react'
import ArrowBack from '@public/images/icons/arrow-right-black.svg'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getInrFormat } from '@utils/inrFormatter'
import Image from 'next/image'
import styles from './autoWidget.module.scss'

interface ContinueInsuringProps {
  text: string
  imageUrl: string
  price: number
  redirectUrl: string
  commonSegmentEventProps: any
}

const ContinueInsuringCard: React.FC<ContinueInsuringProps> = ({
  text,
  imageUrl,
  price,
  redirectUrl,
  commonSegmentEventProps,
}) => {
  const handleClick: () => Promise<void> = async () => {
    try {
      await trackEvent('tap_btn_CTA_widget', {
        ...commonSegmentEventProps,
        ...{ funnel: 'continue_entry' },
        action_type: 'Continue',
      }).catch(err => {
        console.error(err)
      })
    } catch (err) {
      console.error(err)
    }
    window.location.href = redirectUrl
  }
  return (
    <div
      className={styles.roundedBoxWrapper}
      onClick={() => {
        void handleClick()
      }}>
      <div className={styles.imageContainer}>
        <Image width={24} height={24} className="rounded-box-image" src={imageUrl} alt="brand-logo" />
      </div>
      <div className={styles.roundedBoxTextContainer}>
        <div className={styles.roundedBoxText}>
          Continue insuring your{' '}
          <span>
            {text} starting at {getInrFormat(price, true)}.
          </span>
        </div>
      </div>
      <div className={styles.arrowIconContainer}>
        <ArrowBack />
      </div>
    </div>
  )
}

export default ContinueInsuringCard
